import { Component, Input, Output, EventEmitter, input } from '@angular/core';
import { ChitinIconComponent } from '@shared/components/chitin/atoms/icon/chitin-icon.component';

@Component({
  selector: 'chitin-accordion',
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
  imports: [ChitinIconComponent],
})
export class ChitinAccordionComponent {
  @Input()
  title?: string;
  @Input()
  isOpen: boolean = false;

  titleIcon = input<string>();
  titleIconColor = input<'primary' | 'danger' | 'success' | 'secondary' | 'text' | 'lighter-blue' | 'pink' | 'white'>();
  titleEnd = input<string>();

  @Output()
  isOpenChanges = new EventEmitter<boolean>();

  protected toggleOpen() {
    this.isOpen = !this.isOpen;
    this.isOpenChanges.next(this.isOpen);
  }
}
